<template>
  <div class="about">
    <div class="top">
      <div class="title">发展历程</div>
      <div class="box">
        <div class="left">
          <div class="sam_left" :style="{ marginTop: -lc_l * 8.5 + 'vw' }">
            <div
              v-for="(item, index) in tab3"
              :key="index"
              @click="changeLc(index)"
            >
              {{ item.year }}
              <img :src="curindex == index ? img[1] : img[0]" alt="" />
            </div>
          </div>
        </div>
        <div class="right">
          <!-- <div
            class="txt"
            v-for="(item, index) in tab3[curindex].list"
            :key="index"
            v-html="item.content"
          >
            恒生携手IHS
            Markit（埃信华迈）成立合资公司，致力于用技术支持中国债券市场对外开放
          </div> -->
          <div class="swiper-container right-swiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide txt"
                v-for="(item, index) in tab3[curindex].list"
                :key="index"
              >
                <div v-html="item.content"></div>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="list">
        <p>{{ tab4_2[0] && tab4_2[0].title }}</p>
        <p></p>
        <p>{{ tab4_2[0] && tab4_2[0].content }}</p>
      </div>

      <div class="list">
        <p>{{ tab4_2[1] && tab4_2[1].title }}</p>
        <p></p>
        <p>{{ tab4_2[1] && tab4_2[1].content }}</p>
      </div>

      <div class="list">
        <p>{{ tab4_2[2] && tab4_2[2].title }}</p>
        <p></p>
        <div class="box">
          <div
            v-for="(item, index) in tab4_2[2] && tab4_2[2].explode"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      tab4_2: [],
      tab3: [{ list: [] }],
      curindex: 0,
      lc_l: 0, //上次最左边的下标
      img: [
        require("../assets/img01/che.png"),
        require("../assets/img01/che1.png"),
      ],
      swiper: null,
    };
  },
  methods: {
    //数据请求
    getdata() {
      this.$fetch({
        url: "/index.php/about/initPage",
      }).then((res) => {
        this.tab4_2 = res.data.tab4_2;
        this.tab3 = res.data.tab3;
        this.$nextTick(() => {
          this.getswiper();
        });
      });
    },
    //left点击
    changeLc(index) {
      let lc_l = this.lc_l,
        len = this.tab3.length;
      //console.log(index,len,lc_l)
      if (index - lc_l > 3) {
        this.lc_l = len - lc_l - 7 >= index - lc_l - 3 ? index - 3 : len - 7;
      } else if (index - lc_l < 3) {
        this.lc_l = index > 3 ? lc_l - (3 - (index - lc_l)) : 0;
      }
      this.curindex = index;
      this.$nextTick(() => {
        this.swiper.slideTo(0, 0, false);
        this.getswiper();
      });
    },
    //轮播
    getswiper() {
      if (this.swiper) this.swiper.destroy(false);
      this.swiper = new Swiper(".swiper-container", {
        direction: "vertical", // 垂直切换选项
        // loop: false,
        slidesPerView: 3,
        centeredSlidesBounds: true,
        // 如果需要分页器
        // pagination: ".swiper-pagination",
      });
    },
  },
  mounted() {
    this.getdata();
  },
};
</script>

<style scoped>
.top {
  padding-top: 68px;
}
.top .title {
  /* width: 160px; */
  height: 50px;
  text-align: center;
  margin: 0 auto 47px;
  font-size: 36px;
  font-weight: 400;
  color: #333333;
  line-height: 50px;
  letter-spacing: 4px;
}
.top .box {
  width: 690px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.top .box .left {
  position: relative;
  height: 90.86667vw;
  overflow: hidden;
}
.top .box .left::after {
  content: "";
  position: absolute;
  right: 20px;
  top: 10px;
  width: 2px;
  height: 637px;
  background: #eeeeee;
  z-index: -1;
}
.top .box .left .sam_left {
  height: max-content;
  transition: all 0.3s ease;
}
.top .box .left .sam_left div {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  font-size: 24px;
  font-weight: 400;
  color: #333333;
  line-height: 33px;
}
.top .box .left .sam_left div > img {
  width: 42px;
  height: 42px;
}
.top .box .right >>> .right-swiper {
  height: 620px;
  padding: 2px 5px;
  overflow: hidden;
}
.top .box .right .txt {
  width: 551px;
  height: 180px !important;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  font-size: 28px;
  font-weight: 400;
  color: #333333;
  line-height: 45px;
  padding: 18px 19px 27px 26px;
  margin-bottom: 30px;
}
.top .box .right .txt >>> p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.bottom {
  width: 750px;
  height: 836px;
  margin-top: 50px;
  background: url(../assets/imgapp/big.png);
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
}
.bottom .list {
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  width: 690px;
  margin: 0 auto;
}
.bottom .list:nth-child(3) {
  border: none;
}
.bottom .list p:nth-child(1) {
  font-size: 36px;
  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  letter-spacing: 4px;
  margin-top: 40px;
}
.bottom .list p:nth-child(2) {
  width: 40px;
  height: 4px;
  background: #ffffff;
  margin: 20px auto;
}
.bottom .list p:nth-child(3) {
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  line-height: 56px;
  margin-bottom: 40px;
}
.bottom .list .box {
  width: 628px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.bottom .list .box > div {
  width: 170px;
  height: 56px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  margin-right: 25px;
  margin-bottom: 25px;
}


</style>